import React, { useState } from "react";
import "./Login.css";
import { Link } from "react-router-dom";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  // Toggle password visibility
  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  return (
    <div className="login-page">
      {/* Animated Background */}
      <div className="background">
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
      </div>

      {/* Login Form */}
      <div className="login-container">
        <h2 className="login-title">Welcome Register </h2>
        <form className="login-form">
          <div className="form-group">
            <label>User Name</label>
            <input type="text" placeholder="Enter your name" required />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" placeholder="Enter your email" required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                required
              />
              <span className="toggle-icon" onClick={togglePassword}>
                {showPassword ? "👁️" : "🙈"}
              </span>
            </div>
          </div>
          <div className="form-group">
            <label>Confirm Password</label>{" "}
            <div className="password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Enter your password"
                required
              />
              <span className="toggle-icon" onClick={toggleConfirmPassword}>
                {showConfirmPassword ? "👁️" : "🙈"}
              </span>
            </div>
          </div>
          {/* Link to Signup Page */}
          <div className="signup-link mb-2 mr-1 flex  justify-end">
            <p>
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </div>
          <button type="submit" className="login-btn">
            Register
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
